module.exports = __webpack_public_path__ + "img/google-gemini-icon.efc4a5f2.png";